import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { TableBySerialData } from "./types";
import zoomPlugin from "chartjs-plugin-zoom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin,
);

const ChartBarSerial: React.FC<TableBySerialData> = ({
  verticalSize,
  serials,
}) => {
  const labels = serials.map((el) => el.name);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "Обращения",
        data: serials.map((i) => i.summary_problems),
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        barPercentage: 1,
        categoryPercentage: 0.7,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      zoom: {
        zoom: {
          mode: "x" as "x" | "y" | "xy",
          wheel: {
            enabled: true,
          },
          pinch: {
            enabled: true,
          },
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "Количество обращений по оборудованию",
      },
      tooltip: {
        callbacks: {
          title: (tooltipItems: any) => {
            return tooltipItems[0].label;
          },
          label: (tooltipItem: any) => {
            const dataPoint = tooltipItem.raw;
            return `Обращения: ${dataPoint}`;
          },
          afterLabel: (tooltipItem: any) => {
            const data = serials.find((el) => el.name === tooltipItem.label);
            if (!data) return;

            return [
              `Низкий: ${data.problem_lvl_low}`,
              `Средний: ${data.problem_lvl_mid}`,
              `Стандартный: ${data.problem_lvl_standart}`,
              `Высокий: ${data.problem_lvl_high}`,
              `Критический: ${data.problem_lvl_critical}`,
            ];
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: verticalSize,
      },
    },
  };

  return <Bar data={chartData} options={options} />;
};

export default ChartBarSerial;
